export default __webpack_public_path__ + "static/media/past_order.47fcafed.mp3";